import { render, staticRenderFns } from "./ViewContract.vue?vue&type=template&id=27968178&scoped=true"
import script from "./ViewContract.vue?vue&type=script&lang=js"
export * from "./ViewContract.vue?vue&type=script&lang=js"
import style0 from "./ViewContract.vue?vue&type=style&index=0&id=27968178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27968178",
  null
  
)

export default component.exports